var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionnaire"},[(_vm.activeQuestionId !== 0)?_c('Substrate',[_c('Question')],1):_c('UserInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }